import { acceptanceAPI } from "./api";

// ── Шаги приёмки ────────────────────────────────────────

export const getAcceptanceSteps = async (params = {}) => {
  try {
    const res = await acceptanceAPI.getAcceptanceSteps(params);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const updAcceptanceStep = async (data) => {
  try {
    const res = await acceptanceAPI.updAcceptanceStep(data);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const deleteAcceptanceStep = async (id) => {
  try {
    const res = await acceptanceAPI.deleteAcceptanceStep(id);
    return res?.data;
  } catch (e) {
    return null;
  }
};

// ── Приёмка ─────────────────────────────────────────────

export const getAcceptances = async (params = {}) => {
  try {
    const res = await acceptanceAPI.getAcceptances(params);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const updAcceptance = async (data) => {
  try {
    const res = await acceptanceAPI.updAcceptance(data);
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const deleteAcceptance = async (id) => {
  try {
    const res = await acceptanceAPI.deleteAcceptance(id);
    return res?.data;
  } catch (e) {
    return null;
  }
};

// ── Справочники для селектов ────────────────────────────

export const getWorkSetCheckGroups = async () => {
  try {
    const res = await acceptanceAPI.getWorkSetCheckGroups();
    return res?.data;
  } catch (e) {
    return null;
  }
};

export const getAssignTypes = async () => {
  try {
    const res = await acceptanceAPI.getAssignTypes();
    if (res && typeof res === "object" && "data" in res) {
      return res.data;
    }
    if (Array.isArray(res)) {
      return res;
    }
    return [];
  } catch (e) {
    return [];
  }
};

// ── Колонки таблицы: Шаги приёмки ───────────────────────

export const stepsTableColumns = [
  {
    name: "acceptance_step_id",
    required: true,
    label: "ID",
    align: "center",
    field: "acceptance_step_id",
    sortable: true,
  },
  {
    name: "acceptance_step_name",
    required: true,
    label: "Название",
    align: "left",
    field: "acceptance_step_name",
    sortable: true,
  },
  {
    name: "acceptance_step_code",
    required: true,
    label: "Код",
    align: "left",
    field: "acceptance_step_code",
    sortable: true,
  },
  {
    name: "description",
    label: "Описание",
    align: "center",
    field: "description",
    sortable: false,
  },
  {
    name: "is_default",
    label: "Обязательно",
    align: "center",
    field: "is_default",
    sortable: true,
  },
  {
    name: "is_active",
    label: "Активен",
    align: "center",
    field: "is_active",
    sortable: true,
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];

// ── Колонки таблицы: Приёмка ────────────────────────────

export const acceptanceTableColumns = [
  {
    name: "acceptance_id",
    required: true,
    label: "ID",
    align: "center",
    field: "acceptance_id",
    sortable: true,
  },
  {
    name: "work_set_check_group_name",
    required: true,
    label: "Группа работ",
    align: "left",
    field: "work_set_check_group_name",
    sortable: true,
  },
  {
    name: "acceptance_step_name",
    required: true,
    label: "Шаг приёмки",
    align: "left",
    field: "acceptance_step_name",
    sortable: true,
  },
  {
    name: "assign_type_name",
    required: true,
    label: "Исполнитель",
    align: "left",
    field: "assign_type_name",
    sortable: true,
  },
  {
    name: "order_num",
    label: "Порядок",
    align: "center",
    field: "order_num",
    sortable: true,
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];

/** Колонки шагов внутри раскрытой группы работ (без колонки группы). */
export const acceptanceGroupStepsTableColumns = [
  {
    name: "acceptance_id",
    required: true,
    label: "ID",
    align: "center",
    field: "acceptance_id",
    sortable: true,
  },
  {
    name: "acceptance_step_name",
    required: true,
    label: "Шаг приёмки",
    align: "left",
    field: "acceptance_step_name",
    sortable: true,
  },
  {
    name: "assign_type_name",
    required: true,
    label: "Исполнитель",
    align: "left",
    field: "assign_type_name",
    sortable: true,
  },
  {
    name: "order_num",
    label: "Порядок",
    align: "center",
    field: "order_num",
    sortable: true,
  },
  {
    name: "actions",
    label: "",
    align: "center",
    field: "actions",
  },
];
